import { render, staticRenderFns } from "./RolesAgent.vue?vue&type=template&id=f9f36de0"
import script from "./RolesAgent.vue?vue&type=script&lang=js"
export * from "./RolesAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports